<template>

 
    <div class="controls ">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
        </head>  
        <button class="button" 
                v-if="!deviceCharacteristic"
                :class="{'is-warning': !deviceCharacteristic, 'is-success' : deviceCharacteristic }" 
                :disabled="deviceCharacteristic"
                id="pair" v-on:click="connect">connect sensor</button>
        <div v-if="deviceCharacteristic">   

            <div class="tile connected notification is-primary">

            
                
                    
                <div class="tile is-parent sonsorData" v-if="!sensorError">
                    
                    <div class="tile is-child content is-large">
                        <div class="">Light : {{lightIntensity}} W/m2</div>
                        <div class="">Tpanel: {{moduleTemperature}} C</div> 
                    </div>
                    
                    <div class="tile is-child content is-small">                        
                        <div class="">Icell: {{Icell}} mA</div>
                        <div class="">Tcell: {{cellTemperature}} C</div>                                                   
                        <div class="" v-if="lastUpdated">{{lastUpdated.toLocaleTimeString()}}:{{ Math.floor(lastUpdated.getMilliseconds()/100)}} </div>
                    </div>                    
                </div>
                <div class="tile tile is-child notification is-danger" v-if="sensorError">{{sensorError}}</div>

                
                

            </div>
            

            <!-- <input class="input" type="input" v-model="messageToSend" placeholder="messageToSend">      
            <button class="button"
                v-if="!sendLocked" 
                id="sendButton" 
                :disabled="sendLocked"
                v-on:click="send">Send</button>
            <figure class="image is-128x128" v-if="deviceCharacteristic && sendLocked">
                <img src="..\assets\spinner.gif">
            </figure> -->
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: "LightAndTemperature",
    data() {
        return {
            lightIntensity: undefined,
            cellTemperature: undefined,           
            moduleTemperature: undefined,
            Icell: undefined,
            sensorError: undefined,
            serviceUUID : "0000ffe0-0000-1000-8000-00805f9b34fb",
            characteristicId : "0000ffe1-0000-1000-8000-00805f9b34fb",
            deviceCharacteristic : null,
            endChar : '&',   
            //endChar : '/n',   
            message: '',  
            locked: false,
            messageToSend: undefined,
            lastUpdated: undefined,
        }
    },
    mounted () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been rendered
            // const button = document.getElementById('pair');
            // button.addEventListener('pointerup', function () {
                // this.connect();
            // });
        })
    },
    computed: {
        sendLocked() {
            return this.locked || !this.deviceCharacteristic;
        }
    },
    methods: {      
        ...mapActions(['setLightAction', 'setPanelTemperatureAction','setSensorConnectedAction']),   
        onNewMessage(msg) {            
            if (!msg)
                return;
            const index = msg.indexOf(this.endChar);
            if (index >= 0) {
                let newMsg = msg.substring(0, index);
                this.message += newMsg;
                if (index === msg.length - this.endChar.length) {
                    msg = "";
                }
                else {
                    msg = msg.substring(index + this.endChar.length, msg.length);
                }
                // TODO: handle message
                this.proccessMessage(this.message);
                //console.log(this.message);                
                this.locked = false;
                this.message = "";
                if (msg) {
                    this.onNewMessage(msg);
                }
            }
            else {
                this.message += msg;
            }

        },

        onSensorDisconnected(){
            console.log("on sensor disconected");
            this.$data.deviceCharacteristic = null;  
            this.setSensorConnectedAction(false);          
        },

        proccessMessage(msg){
            try{
                var obj = JSON.parse(msg);
                this.$data.cellTemperature = Math.round(obj.Tc/100);
                this.$data.moduleTemperature = Math.round(obj.Tm/100);
                this.$data.lightIntensity = obj.light;
                this.$data.Icell = obj.Ic;
                this.$data.sensorError = undefined;

                this.setPanelTemperatureAction(this.$data.moduleTemperature);
                this.setLightAction(this.$data.lightIntensity);  
                if(!this.$store.state.isSensorConnected) 
                {
                    this.setSensorConnectedAction(true);             
                }
            }
            catch(ex)
            {
                this.$data.sensorError = "Error to parse msg JSON";
                console.log("Error to parse msg JSON. msg:");
                console.log(msg);

                console.log("Exeption:");
                console.log(ex);
            }

            this.$data.lastUpdated = new Date(Date.now());

        },

        handleCharacteristicValueChanged(event) {
            const value = event.target.value;
            const length = value.byteLength;
            if (length <= 0)
                return;
            let msg = String.fromCharCode([value.getUint8(0)]);

            for (var i = 1; i < length; i++) {
                msg += String.fromCharCode([value.getUint8(i)]);
            }
            this.onNewMessage(msg);
            //console.log('Received ' + msg);
        },

        async connect(){
            //navigator.bluetooth.requestDevice({ filters: [{ services: ['heart_rate'] }] });

            document.addEventListener('onSensorDisconnected',this.onSensorDisconnected);

            navigator.bluetooth.requestDevice({
                acceptAllDevices: true,
                optionalServices: [this.serviceUUID]
            })
            .then(device => {
                // Human-readable name of the device.
                console.log(device.name);
                device.ongattserverdisconnected = function () {                                        
                    console.log("Senso disconnected");
                    document.dispatchEvent(new CustomEvent('onSensorDisconnected', {}));
                };
                // Attempts to connect to remote GATT Server.
                return device.gatt.connect();
            })
            .then(server => {
                //console.log(server);
                return server.getPrimaryService(this.serviceUUID);
            })
            .then(service => {
                console.log(service);
                //return service.getCharacteristic
                return service.getCharacteristic(this.characteristicId);
            })
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
                characteristic.addEventListener('characteristicvaluechanged',
                    this.handleCharacteristicValueChanged);
                console.log('Notifications have been started.');
                this.deviceCharacteristic = characteristic;                
            })
            .catch(error => {
                console.log(error);
                this.deviceCharacteristic = null;
            });
        },

        send(){
             if (this.deviceCharacteristic == null) {
                console.log('writer is null');
            }
            else {
                this.locked = true;
                console.log('write ...');
                var value = Uint8Array.of(31);
                this.deviceCharacteristic.writeValue(value);
                console.log('sent');                
            }
        },


    },    
    
}
</script>